import { render, staticRenderFns } from "./DefaultInfo.vue?vue&type=template&id=de503d78"
import script from "./DefaultInfo.vue?vue&type=script&lang=js"
export * from "./DefaultInfo.vue?vue&type=script&lang=js"
import style0 from "./DefaultInfo.vue?vue&type=style&index=0&id=de503d78&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports